




















































import { Component, Vue } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { LdapImportResult, LdapImportStatus } from '@/models'

@Component
export default class LdapImportAccountsModal extends Vue {
  private emailsText = ''
  private loading = false
  private results: LdapImportResult[] = []

  get parsedEmails(): string[] {
    return this.emailsText
      .split(/[,\n;]+/)
      .map(email => email.trim().toLowerCase())
      .filter(email => email.length > 0)
      .filter((email, index, all) => all.indexOf(email) === index)
  }

  get fields() {
    return [
      { key: 'email', label: this.$t('ldap_import_accounts.col_email') },
      { key: 'status', label: this.$t('ldap_import_accounts.col_status') }
    ]
  }

  get tableItems() {
    return this.results.map(result => {
      const managers = result.status === 'CREATED' && result.managersAssigned
        ? this.$t('ldap_import_accounts.managers_assigned', { count: result.managersAssigned }).toString()
        : ''
      return {
        email: result.accountId || result.email,
        statusLabel: this.statusLabel(result.status),
        _variant: this.statusVariant(result.status),
        detail: result.message || managers
      }
    })
  }

  get summaryText(): string {
    const count = (status: LdapImportStatus) => this.results.filter(r => r.status === status).length
    return this.$t('ldap_import_accounts.summary', {
      created: count('CREATED'),
      exists: count('ALREADY_EXISTS'),
      notFound: count('NOT_FOUND_IN_LDAP'),
      error: count('ERROR')
    }).toString()
  }

  statusLabel(status: LdapImportStatus): string {
    const keys: Record<LdapImportStatus, string> = {
      CREATED: 'ldap_import_accounts.status_created',
      ALREADY_EXISTS: 'ldap_import_accounts.status_exists',
      NOT_FOUND_IN_LDAP: 'ldap_import_accounts.status_not_found',
      ERROR: 'ldap_import_accounts.status_error'
    }
    return this.$t(keys[status]).toString()
  }

  statusVariant(status: LdapImportStatus): string {
    const variants: Record<LdapImportStatus, string> = {
      CREATED: 'success',
      ALREADY_EXISTS: 'secondary',
      NOT_FOUND_IN_LDAP: 'warning',
      ERROR: 'danger'
    }
    return variants[status]
  }

  async submit() {
    if (this.parsedEmails.length === 0) {
      return
    }
    this.loading = true
    try {
      this.results = await ApiClient.importLdapAccounts(this.parsedEmails)
      const created = this.results.filter(r => r.status === 'CREATED').length
      if (created > 0) {
        this.$emit('imported', created)
      }
    } catch (error) {
      this.$bvToast.toast((error as Error).message, {
        title: this.$t('ldap_import_accounts.error_title').toString(),
        variant: 'danger',
        solid: true
      })
    } finally {
      this.loading = false
    }
  }

  hide() {
    const modal = this.$refs.modal as any
    if (modal) {
      modal.hide()
    }
  }

  onHidden() {
    this.emailsText = ''
    this.results = []
    this.loading = false
  }
}
